import { Search, X } from "lucide-react";
import { useEffect, useId, useRef, useState } from "react";

import { PHONE_COLLECTION_SEARCH_QUERY } from "../lib/responsive";

export function CollectionSearch({
  label,
  value,
  onChange,
  placeholder,
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
}) {
  const inputId = useId();
  const fieldId = `${inputId}-field`;
  const inputRef = useRef<HTMLInputElement>(null);
  const [isPhone, setIsPhone] = useState(() => window.matchMedia(PHONE_COLLECTION_SEARCH_QUERY).matches);
  const [mobileOpen, setMobileOpen] = useState(false);
  const inputVisible = !isPhone || mobileOpen;

  useEffect(() => {
    const media = window.matchMedia(PHONE_COLLECTION_SEARCH_QUERY);
    const updatePhone = (event: MediaQueryListEvent) => {
      setIsPhone(event.matches);
      if (!event.matches) setMobileOpen(false);
    };

    setIsPhone(media.matches);
    media.addEventListener("change", updatePhone);
    return () => media.removeEventListener("change", updatePhone);
  }, []);

  useEffect(() => {
    if (isPhone && mobileOpen) inputRef.current?.focus();
  }, [isPhone, mobileOpen]);

  return (
    <div className="collection-search" role="search">
      {isPhone && (
        <button
          type="button"
          className="collection-search__trigger"
          aria-label={label}
          aria-controls={fieldId}
          aria-expanded={mobileOpen}
          onClick={() => setMobileOpen(true)}
        >
          <Search size={19} />
        </button>
      )}
      <div id={fieldId} hidden={!inputVisible}>
        {inputVisible && (
          <label className="collection-search__field" htmlFor={inputId}>
            <span>{label}</span>
            <input
              ref={inputRef}
              id={inputId}
              type="search"
              value={value}
              onChange={(event) => onChange(event.target.value)}
              onKeyDown={(event) => {
                if (isPhone && event.key === "Escape") setMobileOpen(false);
              }}
              placeholder={placeholder}
            />
            {value && (
              <button className="collection-search__clear" type="button" aria-label="Cancella ricerca" onClick={() => onChange("")}>
                <X size={17} />
              </button>
            )}
          </label>
        )}
      </div>
    </div>
  );
}
